// extracted by mini-css-extract-plugin
export default {"bg":"bg__nh95a","callScreen":"callScreen__kvo9u","btnCall":"btnCall__sg5lI"};